import React from 'react'
import { confirmable, createConfirmation } from 'react-confirm'
import { useTranslation } from 'react-i18next'
import { ThemeProvider } from 'styled-components'

import ServiceModal from './ServiceModal'
import theme from 'config/theme'

const ConfirmModal = ({ show, proceed, dismiss, cancel, onClose, ...confirmProps }) => {
	const [t] = useTranslation()
	const texts = {
		label: confirmProps.label || t('common.buttons.confirm'),
		text: confirmProps.text || t('common.strings.delete_data'),
		btnText: confirmProps.btnText || t('common.strings.yes'),
		btnCancelText: confirmProps.btnCancelText || t('common.buttons.abort')
	}

	return(
		<ThemeProvider theme={theme}>
			{show &&
				<ServiceModal
					type='confirm'
					{...confirmProps}
					{...texts}
					onClose={() => {
						dismiss()
						if(typeof onClose === 'function') {
							onClose()
						}
					}}
					onOk={proceed}
					onCancel={cancel}
					theme={theme} />
			}
		</ThemeProvider>
	)
}

const withConfirm = createConfirmation(confirmable(ConfirmModal))
const confirmation = confirmProps => withConfirm(confirmProps)

export default confirmation
